import AddMoney from '../Action/ActionTypes/AddMoneyTypes';
import CancelSubscription from '../Action/ActionTypes/CancelType';
import ContactUS from '../Action/ActionTypes/ContactTypes';
import CreateSubscription from '../Action/ActionTypes/CreateSub';
import Filled_details from '../Action/ActionTypes/Filled_details';
import downloadInvoice from '../Action/ActionTypes/DownloadInvoice';
import forgotPassword from '../Action/ActionTypes/ForgotPassword';
import freeSignup from '../Action/ActionTypes/FreeSignup';
import freeTrial from '../Action/ActionTypes/FreeTrial';
import InitiateSubscription from '../Action/ActionTypes/initiatePayment';
import InviteUser from '../Action/ActionTypes/Inviteuser';
import LogoutUser from '../Action/ActionTypes/LogoutTypes';
import mobileDropdwon from '../Action/ActionTypes/MobileDropdown';
import ProfilePic from '../Action/ActionTypes/ProfilePic';
import UserProfile from '../Action/ActionTypes/ProfileType';
import RemoveUser from '../Action/ActionTypes/RemoveUser';
import resetPassword from '../Action/ActionTypes/ResetPassword';
import SubscriptionType from '../Action/ActionTypes/SubscriptionType';
import TeamData from '../Action/ActionTypes/TeamType';
import UpdatePic from '../Action/ActionTypes/UpdatePic';
import UserSignupType from '../Action/ActionTypes/UserSignup';
import ValidSub from '../Action/ActionTypes/ValidSub';
import VerifyMail from '../Action/ActionTypes/VerifyMail';
import WalletType from '../Action/ActionTypes/WalletActionTypes';
import Product_plan from '../Action/ActionTypes/Product_plan';
import CreateLite from '../Action/ActionTypes/CreateLite';
import Lite_loader from '../Action/ActionTypes/Lite_loader';
import Onboarding from '../Action/ActionTypes/Onboarding';
import VerifySignup from '../Action/ActionTypes/VerifySignup';
import ShowSignup from '../Action/ActionTypes/ShowSignup';
import validNum from '../Action/ActionTypes/ValidNum';
import subscriptions from '../Action/ActionTypes/Subscriptions';
import Multi_factor from '../Action/ActionTypes/MultiFactor';
import isEnterpriseUser from '../Action/ActionTypes/EnterpriseUser';
import GetChargeTypes from '../Action/ActionTypes/GetChargeTypes';
import OpenDetailsModal from '../Action/ActionTypes/OpenDetailsModal';
import CheckDailyLimit from '../Action/ActionTypes/DailyLimit';
import OpenDeskModal from '../Action/ActionTypes/OpenDeskModal';
import OpenDailyLimit from '../Action/ActionTypes/OpenDailyLimit';
import ToggleController from '../Action/ActionTypes/ToggleController';
import validCoupon from '../Action/ActionTypes/ValidateCoupon';

const initialState = {
  tab: 'profile',
  openContact: false,
  openFreeTrial: false,
  ft_product: '',
  ft_plan: '',
  freeSignup: false,
  signupState: false,
  msg: '',
  open: '',
  enterprise: false,
  contactPlan: '',
  profile: '',
  teams: {},
  userSignup: '',
  wallet: '',
  invoice: '',
  subscription: '',
  subscriptions: '',
  contact: '',
  cancelSub: '',
  createSub: '',
  createLite: '',
  initiate: '',
  photo: '',
  updatePhoto: '',
  forgotPassword: '',
  resetPassword: '',
  setFpScreen: false,
  setResetScreen: false,
  passwordError: '',
  validSub: false,
  details_filled: false,
  verifyMail: '',
  mobile: false,
  product: '',
  plan: '',
  lite_loader: false,
  onboarded: false,
  verifySignup: false,
  showSignup: true,
  valid_num: null,
  multiAuth: false,
  isEnterpriseUser: false,
  subscriptionStatus: null,
  enterprisePlan: null,
  enterpriseProduct: null,
  advancePlans: ['PROPLUS', 'ENTERPRISE', 'ENTERPRISEPLUS', 'POC'],
  subscriptionCharge: null,
  openDetailsModal: false,
  detailsProduct: null,
  modalAction: null,
  paymentPlan: null,
  paymentType: null,
  dailyLimitSet: false,
  openModalDesk: false,
  toggleProduct: null,
  paygCreate: null,
  couponIsValid: {
    data: null,
    isValid: null,
    plan: null,
  },
  previousPayment: false,
  currentTutorial: 'BUY',
};

const customPopUpReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'settings':
      return { ...state, open: action.status, tab: action.tab };
    case 'signupState':
      return { ...state, signupState: action.status };
    case ShowSignup.SHOW_SIGNUP:
      return { ...state, showSignup: action.status };
    case VerifySignup.VERIFY_SIGNUP_SUCCESS:
      return { ...state, verifySignup: action.status };
    case VerifyMail.SEND_MAIL_SUCCESS:
      return { ...state, verifyMail: action.payload };
    case freeSignup.SIGNUP_FREE_TRIAL:
      return { ...state, freeSignup: action.status };
    case Lite_loader.LITE_LOADER_TRUE:
      return { ...state, lite_loader: true };
    case Lite_loader.LITE_LOADER_FALSE:
      return { ...state, lite_loader: false };
    case 'contact':
      return {
        ...state,
        openContact: action.status,
        msg: action.msg,
        enterprise: action.enterprise,
        contactPlan: action.plan,
      };
    case freeTrial.OPEN_FREE_TRIAL: {
      return {
        ...state,
        openFreeTrial: action.status,
        ft_product: action.product,
        ft_plan: action.plan,
        amount: action.amount,
        limitType: action.limit,
      };
    }
    case 'OPEN_PAYMENT_MODAL': {
      return {
        ...state,
        paymentModal: action.status,
        ft_product: action.product,
        ft_plan: action.plan,
        amount: action.amount,
        limitType: action.limit,
      };
    }
    case mobileDropdwon.MOBILE_SUCCESS: {
      return {
        ...state,
        mobile: action.status,
      };
    }
    case forgotPassword.FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        forgotPassword: action.payload,
        setFpScreen: action.setFpScreen,
        passwordError: action.passwordError,
      };
    case resetPassword.RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        resetPassword: action.payload,
        setResetScreen: action.setResetScreen,
        passwordError: action.passwordError,
      };
    case Product_plan.PRODUCT_PLAN_ACQUIRED:
      return { ...state, product: action.product, plan: action.plan };
    case ValidSub.SUB_SUCCESS:
      return {
        ...state,
        validSub: action.status,
      };
    case Filled_details.DETAILS_SUCCESS:
      return {
        ...state,
        details_filled: action.status,
      };
    case CheckDailyLimit.CHECK_DAILY_LIMIT:
      return {
        ...state,
        dailyLimitSet: action.payload,
      };
    case OpenDeskModal.OPEN_DESK_MODAL:
      return {
        ...state,
        openModalDesk: action.status,
      };
    case OpenDailyLimit.OPEN_DAILY_LIMIT:
      return {
        ...state,
        openDailyLimit: action.status,
      };
    case ToggleController.SET_PRODUCT_TOGGLE:
      return {
        ...state,
        toggleProduct: action.payload,
      };
    case Onboarding.ONBOARDING_SUCCESS:
      return {
        ...state,
        onboarded: action.status,
      };
    case UserProfile.FETCH_USER_SUCCESS:
      return {
        ...state,
        profile: action.payload,
      };
    case UserProfile.FETCH_USER_FAIL:
      return { ...state, profile: action.payload };
    case 'postProfile':
      return { ...state, profile: action.payload };
    case ProfilePic.FETCH_PIC_SUCCESS:
      return { ...state, photo: action.payload };
    case UpdatePic.UPDATE_PIC_SUCCESS:
      return { ...state, updatePhoto: action.payload };
    case TeamData.FETCH_TEAM_SUCCESS:
      return { ...state, teams: action.payload };
    case TeamData.FETCH_TEAM_FAIL:
      return { ...state, teams: action.payload };
    case InviteUser.INVITE_USER_SUCCESS:
      return { ...state, teams: action.payload };
    case RemoveUser.REMOVE_USER_SUCCESS:
      return { ...state, teams: action.payload };
    case UserSignupType.USER_SIGNUP_SUCCESS:
      return { ...state, userSignup: action.payload };
    case LogoutUser.LOGOUT_USER_SUCCESS:
      return { ...state, isAuthorised: false };
    case WalletType.WALLET_FETCH_SUCCESS:
      return {
        ...state,
        wallet: action.payload,
      };
    case WalletType.WALLET_FETCH_FAIL:
      return { ...state, wallet: action.payload };
    case downloadInvoice.DOWNLOAD_INVOICE_SUCCESS:
      return { ...state, invoice: action.payload };
    case AddMoney.ADD_MONEY_SUCCESS:
      return { ...state, wallet: action.payload };
    case SubscriptionType.SUBSCRIPTION_FETCH_SUCCESS:
      return {
        ...state,
        subscription: action.payload,
      };
    case subscriptions.FETCH_SUBSCRIPTION:
      return { ...state, subscriptions: action.payload };
    case GetChargeTypes.GET_CHARGE_TYPES:
      return {
        ...state,
        subscriptionCharge: action.subscriptionCharges,
      };
    case OpenDetailsModal.OPEN_DETAILS_MODAL:
      return {
        ...state,
        openDetailsModal: action.status,
        detailsProduct: action.product,
        paymentType: action.types,
        paymentPlan: action.plan,
        modalAction: action.activity,
      };
    case CreateLite.CREATE_LITE_SUCCESS:
      return { ...state, createLite: action.payload };
    case 'Payg_creation':
      return { ...state, paygCreate: action.payload };
    case ContactUS.CONTACT_SUCCESS:
      return { ...state, contact: action.payload };
    case CancelSubscription.CANCEL_SUCCESS:
      return { ...state, cancelSub: action.payload };
    case CreateSubscription.CREATE_SUCCESS:
      return { ...state, createSub: action.payload };
    case InitiateSubscription.INITIATE_SUCCESS:
      return { ...state, initiate: action.payload };
    case validNum.VALID_NUMBER:
      return { ...state, valid_num: action.status };
    case Multi_factor.MULTI_FACTOR_SUCCESS:
      return { ...state, multiAuth: action.status };
    case isEnterpriseUser.IS_ENTERPRISE_USER:
      return {
        ...state,
        isEnterpriseUser: action.status,
        subscriptionStatus: action.subscriptionStatus,
        enterprisePlan: action.plan,
        enterpriseProduct: action.product,
        previousPayment: action.previousPayment,
      };
    case validCoupon.COUPON_IS_VALID:
      return {
        ...state,
        couponIsValid: {
          isValid: action.valid,
          data: action.payload,
          plan: action.plan,
        },
      };
    case 'currentTutorial':
      return {
        ...state,
        currentTutorial: action.curr,
      };
    default:
      return state;
  }
};

export default customPopUpReducer;
